// ============================================================
// Theme Store (Zustand)
// ============================================================
// Controls theme mode and sidebar collapse. Persisted to localStorage.
// Dark mode can be added by extending this store with a dark palette.

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useThemeStore = create(
  persist(
    (set) => ({
      // ── State ────────────────────────────────────
      mode: 'light', // 'light' | 'dark'
      sidebarCollapsed: false,

      // ── Actions ──────────────────────────────────
      toggleMode: () =>
        set((state) => ({
          mode: state.mode === 'light' ? 'dark' : 'light',
        })),

      setMode: (mode) => set({ mode }),

      toggleSidebar: () =>
        set((state) => ({
          sidebarCollapsed: !state.sidebarCollapsed,
        })),

      setSidebarCollapsed: (collapsed) =>
        set({ sidebarCollapsed: collapsed }),
    }),
    {
      name: 'erp_theme_preferences',
      partialize: (state) => ({
        mode: state.mode,
        sidebarCollapsed: state.sidebarCollapsed,
      }),
    }
  )
);

export default useThemeStore;
